if (!customElements.get("cross-product-section-rendering")) {
    class CrossProductSectionRendering extends HTMLElement {
      constructor() {
        super();
        this.externalAbortController = null;
        this.cache = new Map();
        this.lastRenderedUrl = null;
        this.handleRenderComplete = this.handleRenderComplete.bind(this);
      }
  
      connectedCallback() {
        document.addEventListener("renderSection:complete", this.handleRenderComplete);
  
        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", () => this.initOnLoad());
        } else {
          this.initOnLoad();
        }
      }
  
      disconnectedCallback() {
        document.removeEventListener("renderSection:complete", this.handleRenderComplete);
        this.externalAbortController?.abort();
      }
  
      getInitialVariantId() {
        return this.dataset.initialVariantId || null;
      }
  
      initOnLoad() {
        const sectionIds = this.dataset.sectionRenderingIds?.trim();
        if (!sectionIds) return;
  
        const mapEl = this.querySelector(".variant-section-rendering-map");
        if (!mapEl) return;
  
        try {
          const map = JSON.parse(mapEl.textContent);
          const initialVariantId = this.getInitialVariantId();
          if (!initialVariantId) return;
  
          const crossData = map[initialVariantId];
  
          if (crossData?.url) {
            this.renderExternalSections(crossData.url, sectionIds, crossData.id);
          }
        } catch (error) {
          console.error("[cross-product-section-rendering] initOnLoad:", error);
        }
      }
  
      handleRenderComplete(event) {
        const { variant } = event.detail || {};
        if (!variant?.id) return;
  
        const mapEl = this.querySelector(".variant-section-rendering-map");
        const sectionIds = this.dataset.sectionRenderingIds?.trim();
        if (!mapEl || !sectionIds) return;
  
        try {
          const map = JSON.parse(mapEl.textContent);
          const crossData = map[variant.id];
  
          if (crossData?.url) {
            this.renderExternalSections(crossData.url, sectionIds, crossData.id);
          }
        } catch (error) {
          console.error("[cross-product-section-rendering]", error);
        }
      }
  
      renderExternalSections(productUrl, sectionIds, crossProductId) {
        if (this.lastRenderedUrl === productUrl) {
          return;
        }
  
        this.externalAbortController?.abort();
        this.externalAbortController = new AbortController();
  
        const types = sectionIds.split(",").map((s) => s.trim()).filter(Boolean);
        if (!types.length) return;
  
        if (this.cache.has(productUrl)) {
          this.replaceSections(this.cache.get(productUrl), types, crossProductId, productUrl);
          return;
        }
  
        fetch(productUrl, { signal: this.externalAbortController.signal })
          .then((res) => {
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.text();
          })
          .then((html) => {
            this.cache.set(productUrl, html);
            this.replaceSections(html, types, crossProductId, productUrl);
          })
          .catch((error) => {
            if (error.name !== "AbortError") {
              console.error("[cross-product]", error);
            }
          });
      }
  
      replaceSections(html, types, crossProductId, productUrl) {
        const doc = new DOMParser().parseFromString(html, "text/html");
  
        const blockSelectors = this.dataset.blockSelectors;
        if (blockSelectors) {
          blockSelectors.split(",").map((s) => s.trim()).forEach((selector) => {
            const sourceBlock = doc.querySelector(selector);
            const destBlock = document.querySelector(selector);
  
            if (!sourceBlock || !destBlock) {
              return;
            }
  
            destBlock.innerHTML = sourceBlock.innerHTML;
          });
        }
  
        types.forEach((sectionType) => {
          const dynamicClass = `${sectionType}-dynamic-rendering`;
          const sourceEl = doc.querySelector(`.${dynamicClass}`);
          const destEl = document.querySelector(`.${dynamicClass}`);
  
          if (!destEl) return;

          if (!sourceEl) {
            console.warn(`[cross-product] Missing .${dynamicClass}`);
            destEl.hidden = true;
            return;
          }

          destEl.hidden = false;
          destEl.innerHTML = sourceEl.innerHTML;
        });
  
        this.lastRenderedUrl = productUrl;
  
        this.reinitBV(crossProductId, productUrl);
        this.reinitBVReviews(crossProductId, productUrl);
      }
  
      reinitBVReviews(crossProductId, productUrl) {
        const container = document.getElementById('bv-reviews-container');
        if (!container) return;
  
        container.setAttribute('data-bv-product-id', crossProductId);
        container.setAttribute('data-bv-redirect-url', productUrl);
        container.innerHTML = '';
  
        if (window.$BV) {
          window.$BV.ui('rr', 'show_reviews', {
            productId: String(crossProductId),
            containerEl: 'bv-reviews-container'
          });
        } else {
          window.bvCallback = function(BV) {
            BV.ui('rr', 'show_reviews', {
              productId: String(crossProductId),
              containerEl: 'bv-reviews-container'
            });
          };
        }
      }
  
      reinitBV(crossProductId, productUrl) {
        const bvEl = document.querySelector('[data-bv-show="rating_summary"]');
        if (!bvEl) return;
  
        if (!bvEl.id) bvEl.id = 'bv-rating-summary-target';
  
        bvEl.setAttribute('data-bv-product-id', crossProductId);
        bvEl.setAttribute('data-bv-redirect-url', productUrl);
        bvEl.innerHTML = '';
  
        if (window.$BV) {
          window.$BV.ui('rr', 'rating_summary', {
            productId: String(crossProductId),
            containerEl: bvEl.id
          });
        } else {
          window.bvCallback = function(BV) {
            BV.ui('rr', 'rating_summary', {
              productId: String(crossProductId),
              containerEl: 'bv-rating-summary-target'
            });
          };
        }
      }
    }
  
    customElements.define("cross-product-section-rendering", CrossProductSectionRendering);
  }